import { Star, ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";

const testimonials = [
  {
    name: "Juliette Buffard",
    rating: 5,
    date: "il y a 2 semaines",
    text: "Travail impeccable ! Démoussage de toiture par drone rapide, précis et sans risque pour le toit. Résultat parfait, je recommande !",
    visitDate: "novembre"
  },
  {
    name: "Oceane Demange",
    rating: 5,
    date: "il y a 5 mois",
    text: "Super expérience avec Normandy drone. Je recommande vivement !! La qualité du travail est irréprochable. Parfait je suis très contente ! Merci à vous",
    visitDate: "mai"
  },
  {
    name: "Laura Abitbol",
    rating: 5,
    date: "il y a 4 mois",
    text: "Très réactif et fiable! Merci encore à vous, je recommande sans réserve 👍",
    visitDate: "juin"
  },
  {
    name: "Ali Zedira",
    rating: 5,
    date: "il y a 6 mois",
    text: "Absolument ravi du résultat ! Bluffant l'utilisation du drone… travail sérieux et efficace. Je recommande pour vos toitures.",
    visitDate: "juin"
  },
  {
    name: "MME LAM",
    rating: 5,
    date: "il y a 6 mois",
    text: "Entreprises très sérieuses je recommande. Travail de qualité !! Merci encore à Normandy Drone pour leur réactivité.",
    visitDate: "mai"
  },
  {
    name: "Buallion Nawel",
    rating: 5,
    date: "il y a 5 mois",
    text: "Merci Normandy Drone, prestation au top ! Je recommande vivement !",
    visitDate: "juin"
  },
  {
    name: "Olivier Boquet",
    rating: 5,
    date: "il y a 3 mois",
    text: "Nouvelle technologie et professionnel pour le Démoussage de toitures impressionnant et de qualité. Merci",
    visitDate: "août"
  },
  {
    name: "Sarah Kams",
    rating: 5,
    date: "il y a 6 mois",
    text: "Excellent relationnel, merci Normandy Drone. Je recommande !",
    visitDate: "mai"
  },
  {
    name: "Rac KAMS",
    rating: 5,
    date: "il y a 6 mois",
    text: "Prestation de qualité et travail soigné. Je recommande",
    visitDate: "mai"
  },
  {
    name: "Marie Henocq",
    rating: 5,
    date: "il y a 5 mois",
    text: "Au top! Je recommande fortement!",
    visitDate: "juin"
  },
  {
    name: "Zohra Ait Gherbi",
    rating: 5,
    date: "il y a 5 mois",
    text: "Au top, je recommande !",
    visitDate: "juin"
  },
  {
    name: "Jamal",
    rating: 5,
    date: "il y a 7 mois",
    text: "Excellent travail !",
    visitDate: "avril"
  }
];

const GOOGLE_REVIEW_URL = "https://www.google.com/search?sca_esv=8ff73cc9fbbf5111&sxsrf=AE3TifPJwaViaKDksZQF6pLqWp3pD_IJwA:1765282793263&q=normandy+drone+rouen&si=AMgyJEtREmoPL4P1I5IDCfuA8gybfVI2d5Uj7QMwYCZHKDZ-E-IviQgLZfh6455BulABOtIBC_W_t4V293yX8A8BcPpn7WI37ZsVHJBcizwg5Kkm8_JbdU8%3D&uds=AOm0WdFRYvIbG8WuVt20BADsgGfgaOGpkh_JikcJRODZextI5M3nn-cUiQNAsr_Ct_19J3BDV2APkm5DyvjbKyziCneA4MpNrBg3G3LUU3xm2yh8VYGDY7b2wqJlLPF0OLduvdjJLqYb&sa=X&ved=2ahUKEwjEgsjuvrCRAxXxAvsDHR1aBlMQ3PALegQIGRAE&biw=2560&bih=1271&dpr=1.5";

const TestimonialCard = ({ name, rating, date, text, visitDate }: typeof testimonials[0]) => (
  <div className="glass-card p-6 min-w-[320px] max-w-[320px] flex-shrink-0 border border-border/30 hover:border-primary/30 transition-all">
    <div className="flex items-center gap-1 mb-3">
      {Array.from({ length: rating }).map((_, i) => (
        <Star key={i} className="h-4 w-4 fill-primary text-primary" />
      ))}
    </div>
    <p className="text-muted-foreground text-sm leading-relaxed mb-4 line-clamp-4">
      "{text}"
    </p>
    <div className="flex items-center justify-between">
      <div>
        <p className="font-semibold text-foreground text-sm">{name}</p>
        <p className="text-xs text-muted-foreground">Avis Google · {date}</p>
      </div>
    </div>
    <p className="text-xs text-muted-foreground mt-2">Visité en {visitDate}</p>
  </div>
);

const TestimonialsCarousel = () => {
  // Double the testimonials for seamless infinite scroll
  const doubledTestimonials = [...testimonials, ...testimonials];

  return (
    <section className="py-20 overflow-hidden">
      <div className="container mb-10">
        <div className="text-center">
          <h2 className="section-title">Ce que nos clients disent</h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Plus de 10 avis 5 étoiles sur Google. Découvrez les retours de nos clients satisfaits en Normandie.
          </p>
        </div>
      </div>

      {/* Scrolling container - touch scrollable on mobile, auto-scroll on desktop */}
      <div className="relative">
        {/* Mobile: manual scroll */}
        <div className="md:hidden overflow-x-auto scrollbar-hide px-4 -mx-4">
          <div className="flex gap-4 pb-4">
            {testimonials.map((testimonial, index) => (
              <TestimonialCard key={`${testimonial.name}-${index}`} {...testimonial} />
            ))}
          </div>
        </div>
        
        {/* Desktop: auto-scroll animation */}
        <div className="hidden md:block">
          <div className="flex gap-6 animate-scroll">
            {doubledTestimonials.map((testimonial, index) => (
              <TestimonialCard key={`${testimonial.name}-${index}`} {...testimonial} />
            ))}
          </div>
        </div>
      </div>

      {/* CTA */}
      <div className="container mt-10 text-center">
        <Button variant="outline" asChild>
          <a 
            href={GOOGLE_REVIEW_URL} 
            target="_blank" 
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2"
          >
            <ExternalLink className="h-4 w-4" />
            Ajouter un avis sur Google
          </a>
        </Button>
      </div>
    </section>
  );
};

export default TestimonialsCarousel;
